import {useEffect, useMemo, useState} from 'react';
import {CANVAS_ORIENTATION} from '~/common/canvas/constants';
import {canvasRemoveTextBordersAndIcons} from '~/common/canvas/customs/text_border';
import {useCanvas} from '~/common/canvas/hooks/useCanvas';
import {useOrientation} from '~/common/FabricInvitation/EventCreateDesign/hooks/useOrientation';
import {useIsLargishAndUp} from '~/common/hooks/useMatchQuery';

export const useCanvasImage = (fabricArt) => {
  const orientation = useOrientation();
  const isLargishAndUp = useIsLargishAndUp();

  const [image, setImage] = useState();
  const [loaded, setLoaded] = useState(!fabricArt);
  // I'm only setting this to desktop because on /view, on mobile, the image looks 'cropped' for landscape and square
  const getOrientation = CANVAS_ORIENTATION.desktop[orientation];

  const {canvasInstance} = useMemo(
    () =>
      useCanvas(
        null,
        fabricArt,
        (canvas) => {
          canvasRemoveTextBordersAndIcons(canvas);
          setLoaded(true);
          canvas.setZoom(0.5);
          const snapshot = canvas.toDataURL({
            enableRetinaScaling: true,
          });
          setImage(snapshot);
        },
        isLargishAndUp,
        {
          orientation,
          dimensions: getOrientation,
        },
        undefined,
        false
      ),
    [fabricArt, getOrientation, isLargishAndUp, orientation]
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: deps
  useEffect(
    () => () => {
      canvasInstance.setDimensions({width: 1, height: 1});
      canvasInstance.clear();
      canvasInstance.dispose();
    },
    []
  );

  return {image, loading: !loaded};
};
